<template>
    <Badge
        class="inline-flex"
        :color="entityWithSchedulingState.getSchedulingStateBadgeColor()"
    >
        {{ entityWithSchedulingState.getSchedulingStateBadgeLabel() }}
    </Badge>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import Badge from '@/Shared/Component/Badge.vue'
    import type HasSchedulingStateInterface from '@/App/Booking/Shared/Entity/HasSchedulingStateInterface'

    const props = defineProps({
        entityWithSchedulingState: {
            type: Object as PropType<HasSchedulingStateInterface>,
            required: true,
        },
    })
</script>
